<span class="info">
  {{ 'common.alarm-rule.trigger.device-input.info' | translateSafe }}
</span>